<div class="box-top">
  <div class="d-flex flex-row-reverse position-relative d-inline-block">
    <div
      class="box-close position-absolute rounded-3 d-flex justify-content-center align-items-center cursor-pointer my-2 me-2"
      [class.rtl--close]="lang.isRTL"
      [mat-dialog-close]
      (click)="closeModal()"
    >
      <i class="bi bi-x"></i>
    </div>
  </div>
  <div class="notification-greeting w-100 h-100 p-3" [ngClass]="greetingType">
    <div class="greeting-title text-center">
      {{ greetingTitle }}
    </div>

    <div
      class="content-box d-flex flex-column align-items-center rounded-3 mt-3 p-2"
      *ngIf="!isSender"
    >
      <div class="txt-greeting font-18 text-center">
        <ng-container
          *ngIf="data.feedItem?.greeting_info?.type === GreetingType?.birthday"
        >
          {{ key | translate: { name: getFullName } }}
        </ng-container>
        <span
          *ngIf="
            data.feedItem?.greeting_info?.type === GreetingType?.anniversary
          "
          [innerHTML]="
            key
              | translate
                : {
                    name: getFullName,
                    n: anniversaryDuration,
                    o: ordinalSuffix,
                  }
          "
        ></span>
      </div>
      <div
        class="box-img d-flex justify-content-center align-items-center position-relative mt-3"
      >
        <img
          *ngIf="!!data?.item?.recipient_data?.profile_pic_url"
          class="img-usr mt-3 p-2 rounded-4"
          [src]="img + data?.item?.recipient_data?.profile_pic_url"
        />
        <ng-container *ngIf="!data?.item?.recipient_data?.profile_pic_url">
          <div *ngIf="!!acronym" class="txt--acronym">{{ acronym }}</div>
          <img
            *ngIf="!acronym"
            class="img-usr mt-3 p-2 rounded-4"
            src="assets/img/default-user.png"
          />
        </ng-container>
        <img class="img-small position-absolute" [src]="iconSmall" />
      </div>
      <div class="txt-name fw-bold mt-4">{{ getFullName }}</div>
      <div
        class="txt-date mt-1 text-center p-2 rounded-2 font-12"
        [ngClass]="greetingType"
      >
        <span>{{
          data?.feedItem?.greeting_info?.date | date: "MMM dd, yyyy"
        }}</span>
      </div>

      <div
        class="points-section mt-3 p-2 rounded-3 text-center"
        *ngIf="(data.item?.points ?? 0) > 0"
      >
        <img src="assets/img/stars-gold.png" />
        <div class="points-message">
          {{ "msg.point.youHaveReceived" | translate }}
        </div>
        <div class="points">
          {{ data.item?.points }} {{ "common.point.n" | translate }}
        </div>
      </div>
      <div class="description-section text-center p-2 rounded-2 mt-4">
        {{ data.feedItem?.description }}
        <div
          class="image-section mt-3"
          *ngFor="let image of data.feedItem?.images || []"
        >
          <img
            class="w-100 rounded-2"
            [src]="renderImg(image.display_img_url)"
          />
        </div>
      </div>
      <div
        class="btn btn-primary view-post-btn w-100 mt-3"
        (click)="redirect()"
      >
        {{ "common.viewPost" | translate }}
      </div>
    </div>

    <div
      class="content-box d-flex flex-column align-items-center rounded-3 mt-3 p-2"
      *ngIf="isSender"
    >
      <div
        class="d-flex flex-column box-link align-items-center justify-content-center position-relative mt-5 cursor-pointer"
      >
        <img src="assets/img/appreciate-link.png" />
        <div class="img-love position-absolute">
          <img [src]="iconSmall" class="icon d-inline-block" />
        </div>
        <img
          *ngIf="!!getProfile1"
          class="img-person position-absolute rounded-2 left"
          [src]="getProfile1"
        />
        <div
          *ngIf="!getProfile1"
          class="txt--acronym-small img-person position-absolute rounded-2 left"
        >
          {{ acronym1 }}
        </div>
        <ng-container>
          <img
            *ngIf="!!getProfile"
            class="img-person position-absolute rounded-2 right"
            [src]="getProfile"
          />
          <div
            *ngIf="!getProfile"
            class="txt--acronym-small img-person position-absolute rounded-2 right"
          >
            {{ acronym }}
          </div>
        </ng-container>
      </div>

      <div class="text-center mt-4">
        <span class="fw-bold">{{ getFullName1 }}</span>
        {{ "msg.point.hasWishYou" | translate }}
        {{ greetingTitle }}
      </div>

      <div class="text-muted mt-2">
        {{ data.item?.date }}
      </div>

      <div class="description-section text-center p-2 rounded-2 mt-4">
        {{ data.feedItem?.description }}
        {{ data?.feedItem?.images?.length > 0 ? " - " : "" }}
        <ng-container *ngIf="data?.feedItem?.images?.length > 0">
          <div
            class="image-section mt-3"
            *ngFor="let image of data.feedItem?.images || []"
          >
            <img
              class="w-100 rounded-2"
              [src]="renderImg(image.display_img_url)"
            />
          </div>
        </ng-container>
        <ng-container *ngIf="!!data?.feedItem?.ecard">
          <img class="mt-3 w-100 rounded-2" [src]="data.feedItem.ecard.image" />
        </ng-container>
        <ng-container *ngIf="!!data?.feedItem?.gif">
          <img class="mt-3 w-100 rounded-2" [src]="data.feedItem.gif" />
        </ng-container>
      </div>
    </div>
  </div>
</div>
